import {LocalStorageService} from '../../services/local-storage/local-storage.service';
import {SecureStorage} from '@awesome-cordova-plugins/secure-storage/ngx';
import {AppLanguageService} from '../../services/app-language/app-language.service';
import {ToastService} from '../../services/toast/toast.service';
import {TranslateService} from '@ngx-translate/core';

export const storageFactory = (
    secureStorage: SecureStorage,
    appLanguage: AppLanguageService,
    toast: ToastService,
    translate: TranslateService,
    localStorage: any
): LocalStorageService =>
    new LocalStorageService(secureStorage, appLanguage, toast, translate, localStorage);

